var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLecturer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2157_7923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.7 0C2.81635 0 2.1 0.716347 2.1 1.6V21.3333H1.03333C0.738784 21.3333 0.5 21.5721 0.5 21.8667C0.5 22.1612 0.738784 22.4 1.03333 22.4H4.23333H4.23533H5.3C5.3 19.9492 6.80277 17.8494 8.93712 16.9718C7.71504 16.2214 6.9 14.8725 6.9 13.3333C6.9 10.9769 8.81024 9.06667 11.1667 9.06667C13.5231 9.06667 15.4333 10.9769 15.4333 13.3333C15.4333 14.8726 14.6182 16.2216 13.3959 16.972C14.1913 17.299 14.8985 17.7956 15.4726 18.4156L18.5457 17.1577C19.1167 16.9239 19.7185 16.8837 20.2782 17.0055L24.6924 8.8392C25.1126 8.06181 26.0835 7.77227 26.8608 8.19248C27.6381 8.61264 27.9277 9.58347 27.5075 10.3609L22.5671 19.5006C22.7147 20.6514 22.1641 21.8021 21.1461 22.4H31.9667C32.2612 22.4 32.5 22.1612 32.5 21.8667C32.5 21.5721 32.2612 21.3333 31.9667 21.3333H30.9V1.6C30.9 0.716341 30.1837 0 29.3 0H3.7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3536 9.13066C26.6127 9.27072 26.7092 9.59434 26.5692 9.85344L21.4444 19.3341C21.7197 20.2446 21.2622 21.2321 20.364 21.5998L15.9667 23.3998V31.4665C15.9667 31.7611 15.7279 31.9998 15.4333 31.9998H6.9C6.60544 31.9998 6.36667 31.7611 6.36667 31.4665V22.3998C6.36667 19.7489 8.51568 17.5998 11.1667 17.5998C12.8192 17.5998 14.276 18.4351 15.139 19.7046L18.9497 18.1447C19.5713 17.8902 20.2506 17.9955 20.7566 18.3636L25.6308 9.34624C25.7709 9.08709 26.0945 8.99061 26.3536 9.13066Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 10.1333C9.39937 10.1333 7.96667 11.566 7.96667 13.3333C7.96667 15.1006 9.39937 16.5333 11.1667 16.5333C12.934 16.5333 14.3667 15.1006 14.3667 13.3333C14.3667 11.566 12.934 10.1333 11.1667 10.1333Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2157_7923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLecturer);
export default __webpack_public_path__ + "static/media/lecturer.847b8ba3f732caf514357261bdeedfca.svg";
export { ForwardRef as ReactComponent };